<template>
  <div>
    <a-card>
      <div class="cardBody">
        <p>
          Your OTP has expired. Please verify your mobile number again to
          receive a new OTP
        </p>
        <a-form>
          <div>
            <base-input :label="`Enter One Time Pin`" required>
              <a-input v-model="otp" placeholder="XXXXXX" />
              <div v-if="invalidOtp === true" class="text-danger">
                Invalid OTP
              </div>
            </base-input>
          </div>
          <div>
            <b-button size="sm" variant="primary" @click="verifyOtp">
              Verify OTP
            </b-button>
            <br />
            <br />
            <b-button
              size="sm"
              variant="primary"
              @click="requestOTP"
              :disabled="!canResend"
            >
              Resend OTP
              <span v-if="resendCounting">({{ resendTimeLeft }})</span>
            </b-button>
          </div>
        </a-form>
      </div>
    </a-card>
    <a-modal
      :visible="alreadyExistModal"
      :footer="null"
      @cancel="closeModal"
      :maskClosable="false"
      :closable="false"
    >
    </a-modal>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';

export default {
  props: {
    clpSitePageSettings: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
    },
  },
  name: 'ReOtp',
  data() {
    return {
      verifyMobileNumber: false,
      mobileNumber: null,
      otp: null,
      otpSource: null,
      otpValidity: null,
      invalidOtp: false,
      alreadyExistModal: false,
      duration: 10,
      timeLeft: 0,
      timer: null,
      verifyMobileNumberUrl: '/api/v2/clp_members/check_exist',
      requestOtpUrl: '/api/v2/clp_otp_verifications/generate_otp',
      verifyOtpUrl: '/api/v2/clp_otp_verifications/verify_otp',
      canResend: false,
      resendDuration: 50,
      resendTimeLeft: 0,
      resendTime: null,
      resendCounting: false,
    };
  },
  methods: {
    closeModal() {
      this.alreadyExistModal = false;
    },
    async requestOTP() {
      try {
        const {
          id,
          membership_program_id: membershipProgramId,
          account_id: accountId,
        } = this.clpSitePageSettings;
        const endpointVerifyAccount = this.verifyMobileNumberUrl;
        const endpointRequestOtp = this.requestOtpUrl;
        const payload = {
          account_id: accountId,
          membership_program_id: membershipProgramId,
          site_page_id: id,
          type: 'MBNO',
          value: `+63${this.mobileNumber}`,
        };
        const verifyAccountResult = await HTTPRequest.getRequest(
          endpointVerifyAccount,
          payload
        );
        if (verifyAccountResult.data.is_available) {
          const requestOtp = await HTTPRequest.postRequest(endpointRequestOtp, {
            member: {
              account_id: accountId,
              membership_program_id: membershipProgramId,
              site_page_id: id,
              mobile_number: `+63${this.mobileNumber}`,
            },
          });
          const { source, valid_until } = requestOtp.data;
          if (source) {
            this.otpSource = source;
            this.otpValidity = valid_until;
            this.canResend = false;
            this.cooldownResendOtp();
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    cooldownResendOtp() {
      this.resendTimeLeft = this.resendDuration;
      this.resendCounting = true;
      this.resendTime = setInterval(() => {
        if (this.resendTimeLeft > 0) {
          this.resendTimeLeft--;
        } else {
          clearInterval(this.resendTime);
          this.resendCounting = false;
          this.canResend = true;
        }
      }, 1000);
    },
    async verifyOtp() {
      const {
        id,
        membership_program_id: membershipProgramId,
        account_id: accountId,
      } = this.clpSitePageSettings;
      const endpointVerifyOtp = this.verifyOtpUrl;
      const otp = this.otp;
      if (otp === null) {
        this.invalidOtp = true;
      }
      const mobileNumber = `+63${this.mobileNumber}`;
      const source = this.otpSource;
      const payload = {
        member: {
          account_id: accountId,
          membership_program_id: membershipProgramId,
          site_page_id: id,
          mobile_number: mobileNumber,
        },
        otp: {
          otp_code: otp,
          source: source,
        },
      };

      const verifyOtpResult = await HTTPRequest.patchRequest(
        endpointVerifyOtp,
        payload
      );
      const { error } = verifyOtpResult;
      if (error) {
        this.invalidOtp = true;
        return 0;
      }
      const { is_valid: isValid, valid_until: validUntil } =
        verifyOtpResult.data;

      if (isValid === true) {
        this.otpValidity = validUntil;
        this.invalidOtp = false;
        this.$emit('reotp-success');
      } else {
        this.invalidOtp = true;
      }
    },
  },
  mounted() {
    const { otpConfigDuration } = this.clpSitePageSettings;
    const otpConfig = JSON.parse(otpConfigDuration);
    const data = this.data;

    this.resendDuration = otpConfig.refresh.interval;
    this.mobileNumber = data.mobileNo;
    this.requestOTP();
  },
  beforeDestroy() {
    if (this.resendTime) {
      clearInterval(this.resendTime);
    }
  },
};
</script>

<style scoped>
.centerContent {
  text-align: center;
}
</style>
